export default "/images/crm-hover-dark.svg?11d7fb6057b086c2112e4f505e781989";